import { render, staticRenderFns } from "./GainInsights.vue?vue&type=template&id=cd0e9a3e&scoped=true"
import script from "./GainInsights.vue?vue&type=script&lang=js"
export * from "./GainInsights.vue?vue&type=script&lang=js"
import style0 from "./GainInsights.vue?vue&type=style&index=0&id=cd0e9a3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd0e9a3e",
  null
  
)

export default component.exports